import React, { useState, useEffect } from 'react';
import { Button, Grid } from '@mui/material';
import {
    backgroundColor,
    colorBlack, colorEasyRed,
    colorIcon, colorRed,
    colorSecondary,
    foregroundColor,
    styleSecondaryButton
} from "../App/theme.js";
import SendIcon from '@mui/icons-material/Send';
import StopIcon from '@mui/icons-material/StopOutlined';
import {approximateTokenSize, calcTokensColor, calcTokensOpacity, clearChatHistory, countTotalTokens} from "./utils.js";
import { styled, keyframes } from '@mui/system';
import { useInputValue } from "../Context/ChatInputProvider";
import { createSendMessage } from "./sendMessage";
import {convertHexToRgba, isMobile, publicChatData} from "../App/utils";

const blink = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
`;

const BlinkingIcon = styled(StopIcon)({
    animation: `${blink} 1s cubic-bezier(0.4, 0, 0.6, 1) infinite`,
});

export const ChatButtons = ({ isImageEditor, kbIdAsSubdomain, navigateToChat, isStreaming, setIsStreaming,
                                RequestChatAPI, setKBChats, itemsAreLoading, chatId, addressToAI, messages, setMessages,
                                abortController, sendButtonRef, sendButtonRippleRef
                            }) => {
    const { inputValue, setInputValue } = useInputValue();
    const [totalTokens, setTotalTokens] = useState(0);
    let kbId = kbIdAsSubdomain;

    const sendMessage = createSendMessage({ isStreaming, setMessages, messages, RequestChatAPI, navigateToChat, setKBChats, itemsAreLoading, chatId, inputValue, setInputValue })

    const buttonsBaseStyle = { height: '55px', width: '50%' }

    const sendDisabled = !isStreaming && inputValue.length === 0 || itemsAreLoading;

    useEffect(() => {
        if (!messages) return;
        const fromInput = inputValue ? approximateTokenSize(inputValue) : 0
        setTotalTokens(countTotalTokens(messages) + fromInput);
    }, [messages, inputValue]);

    const formatTokens = (tokens) => {
        return tokens.toLocaleString();
    };

    const SendButton =
        <Button style={{
            ...buttonsBaseStyle,
            marginRight: isMobile ? 0 : 10,
            backgroundColor: sendDisabled ? convertHexToRgba(foregroundColor, 0.4) : undefined,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }}
                variant="contained"
                color="primary"
                ref={sendButtonRef}
                touchRippleRef={sendButtonRippleRef}
                data-testid={sendDisabled ? undefined : "send-button-enabled"}
                disabled={sendDisabled}
                onClick={isStreaming
                    ? () => {
                        abortController?.current?.abort();
                        setIsStreaming(false);
                    }
                    : () => sendMessage({ toChatOnly: !addressToAI })}
                fullWidth
        >
            {isStreaming
                ? <div style={{ display: 'flex', alignItems: 'center' }}>
                    <BlinkingIcon style={{ color: backgroundColor, marginRight: '4px' }} />
                    <span>Stop</span>
                </div>
                : <>
                    <SendIcon style={{ color: sendDisabled ? convertHexToRgba(backgroundColor, 0.6) : backgroundColor, marginBottom: '-4px' }} />
                    {/*{totalTokens > 0 && <div style={{*/}
                    {/*    fontSize: '0.7rem',*/}
                    {/*    marginBottom: '-20px',*/}
                    {/*    marginRight: '-75px',*/}
                    {/*    textAlign: 'right',*/}
                    {/*    width: '100px', // Adjust the width as needed*/}
                    {/*    opacity: calcTokensOpacity(totalTokens),*/}
                    {/*    color: calcTokensColor(totalTokens)*/}
                    {/*}}>~ {formatTokens(totalTokens)} tokens</div>}*/}
                </>
            }
        </Button>

    const NewChat = <Button style={{ ...buttonsBaseStyle, ...styleSecondaryButton, marginRight: isMobile ? 10 : 0 }}
                            variant="outlined" color="primary"
                            disabled={isStreaming || publicChatData}
                            onClick={() => {
                                if (isImageEditor) {
                                    clearChatHistory(kbId, setMessages)
                                } else {
                                    navigateToChat(null)
                                }
                            }}
                            fullWidth
    >
        New Chat
    </Button>

    if (publicChatData) {
        return (
            <Button
                style={{
                    height: '55px',
                    width: '100%',  // Changed to fill container
                    padding: 0,
                    marginLeft: '-4px'
                }}
                variant="contained"
                color="primary"
                ref={sendButtonRef}
                touchRippleRef={sendButtonRippleRef}
                data-testid={sendDisabled ? undefined : "send-button-enabled"}
                disabled={sendDisabled}
                onClick={isStreaming
                    ? () => {
                        abortController?.current?.abort();
                        setIsStreaming(false);
                    }
                    : () => sendMessage({ toChatOnly: !addressToAI })}
            >
                {isStreaming
                    ? <BlinkingIcon style={{ color: backgroundColor }} />
                    : <SendIcon style={{
                        color: sendDisabled
                            ? convertHexToRgba(backgroundColor, 0.6)
                            : backgroundColor
                    }} />
                }
            </Button>
        );
    }


    return (
        <>
            {isMobile ? NewChat : null}
            {isMobile ? SendButton : null}

            {!isMobile ? SendButton : null}
            {!isMobile ? NewChat : null}

        </>
    );
}